
var complete = (arr) => arr.every((v) => v === 1);

function checkNaN(value) {
  return isNaN(value);
}

function isOdd(number) {
  return number % 2 !== 0;
}

function percentages(list) {
  let percentages = [];
  let N = list.length;
  let NaNCheck = list.filter(checkNaN);

  for (let i = 0; i < list.length - 1; i++) {
    if (!isOdd(i) && i + 1 < list.length) {
      // Return clean values
      // (All NANs replaced with 0)
      if (!isNaN(list[i] / list[i + 1])) {
        //  Check if i+1 < i
        if (list[i] > list[i + 1]) {
          percentages.push(1);
          throw {
            name: 'Error: Savings cannot be more than savings',
            message: percentages,
            errorBuffer: i
          };
        } else {
          percentages.push(list[i] / list[i + 1]);
        }
      } else {
        percentages.push(0);
      }
    }
  }
  // Check for NaN
  if (isOdd(N)) {
    throw { name: 'Error: Savings come in pairs', message: percentages };
  }

  // Check where there is something that is not a number within here
  if (NaNCheck.length > 0) {
    let position = list.indexOf(NaNCheck[0]) + 1;
    throw {
      name: `Error: NAN exists in array , position ${position}`,
      message: percentages,
      errorBuffer: position
    };
  }
  return percentages;
}

function conservative(inputsArray, inputNameArray) {
  let args = inputsArray;
  let percentagesList = percentages(args);
  for (let i = 0; i < percentagesList.length - 1; i++) {
    // console.log((percentagesList[i] < percentagesList[i+1]));
    if (
      percentagesList[i] < percentagesList[i + 1] ||
      (percentagesList[i] !== 1 && percentagesList[i + 1] > 0)
    ) {
      /////// Advisory work
      let advisoryArray = new Array(percentagesList.length);
      let stackedArray = new Array(percentagesList.length);
      let typeArray = new Array(percentagesList.length);
      let advisoryStringArray = new Array(percentagesList.length);
      for (let j = 0; j < percentagesList.length; j++) {
        let currentSavings = args[j * 2];
        let objectiveSavings = args[j * 2 + 1];
        if (j > i) {
          advisoryArray[j] = 0;
          stackedArray[j] = percentagesList[j];
          /// No advise
          typeArray[j] = 'Withdraw';

          let currentPercentage = currentSavings / objectiveSavings;
          advisoryStringArray[j] = `Please ${typeArray[j]} ${currentPercentage !== stackedArray[j]
            ? Math.round(stackedArray[j] * objectiveSavings)
            : 'Everything'} from ${inputNameArray[j]} savings`;
        } else {
          advisoryArray[j] = percentagesList[j];
          stackedArray[j] = 0;
          typeArray[j] = 'OKAY';
          advisoryStringArray[j] = `Savings are ${typeArray[j]}`;

          /// Remove funds from this array and invest in immediate previous (i)
        }
      }

      let indicesOfIncompleted = [];
      for (let i = 0; i < percentagesList.length; i++) {
        if (percentagesList[i] < 1) {
          indicesOfIncompleted.push(i);
        }
      }
      // let N = percentagesList.length;

      let interceptPercentage = 100 / percentagesList.length;
      let currentIncompleted;
      if (indicesOfIncompleted.length >= 1) {
        currentIncompleted = percentagesList[indicesOfIncompleted[0]];
      }

      let completedBufferNumber = percentagesList.length - indicesOfIncompleted.length;

      let total = interceptPercentage * completedBufferNumber + currentIncompleted * interceptPercentage;

      /////// Advisory work
      console.log(typeArray);
      return {
        name: `You must complete savings ${i + 1} first before proceeding`,
        message: percentagesList,
        errorBuffer: i,
        advisoryArray,
        stackedArray,
        typeArray,
        advisoryStringArray,
        total,
      };
    }
  }

  let indicesOfIncompleted = [];
  for (let i = 0; i < percentagesList.length; i++) {
    if (percentagesList[i] < 1) {
      indicesOfIncompleted.push(i);
    }
  }

  // let N = percentagesList.length;
  let progressObject;

  let interceptPercentage = 100 / percentagesList.length;
  let currentIncompleted;
  if (indicesOfIncompleted.length >= 1) {
    currentIncompleted = percentagesList[indicesOfIncompleted[0]];
  }

  let completedBufferNumber = percentagesList.length - indicesOfIncompleted.length;

  let total = interceptPercentage * completedBufferNumber + currentIncompleted * interceptPercentage;

  if (percentagesList.length === 1) {
    total = percentagesList[0] * 100;
  }
  /////// Advisory work - when everything is okay
  let advisoryArray = new Array(percentagesList.length);
  let stackedArray = new Array(percentagesList.length);
  let typeArray = new Array(percentagesList.length);
  let advisoryStringArray = new Array(percentagesList.length);

  for (let j = 0; j < percentagesList.length; j++) {
    if (j > indicesOfIncompleted[0]) {
      advisoryArray[j] = 0;
      stackedArray[j] = percentagesList[j];
    } else {
      advisoryArray[j] = percentagesList[j];
      stackedArray[j] = 0;
    }
    /// No advise
    typeArray[j] = 'OKAY';
    advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
  }

  /////// Advisory work

  if (complete(percentagesList)) {
    progressObject = {
      message: 'Congratulations, you have completed your savings',
      total: total,
      results: percentagesList,
      advisoryArray,
      stackedArray,
      typeArray,
      advisoryStringArray
    };
  } else {
    progressObject = {
      message: `Your total percentage is ${Math.round(total)}%`,
      total: total,
      results: percentagesList,
      advisoryArray,
      stackedArray,
      typeArray,
      advisoryStringArray
    };
  }

  return progressObject;
}


function equiservative(inputsArray, inputNameArray) {
  let args = inputsArray;
  let percentagesList = percentages(args);

  let decider = percentagesList[0];

  // console.log(decider);
  for (let i = 1; i < percentagesList.length; i++) {
    if (percentagesList[i] > decider) {
      let reduceBy = (percentagesList[i] - decider) * args[i * 2 - 1];

      /// Advisory work
      let advisoryArray = new Array(percentagesList.length);
      let stackedArray = new Array(percentagesList.length);
      let typeArray = new Array(percentagesList.length);
      let advisoryStringArray = new Array(percentagesList.length);

      for (let j = 0; j < percentagesList.length; j++) {
        let currentSavings = args[j * 2];
        let objectiveSavings = args[j * 2 + 1];

        if (percentagesList[j] > percentagesList[0]) {
          // More error
          advisoryArray[j] = percentagesList[0];
          stackedArray[j] = percentagesList[j] - percentagesList[0];

          let currentPercentage = currentSavings / objectiveSavings;
          typeArray[j] = 'Withdraw';
          advisoryStringArray[j] = `Please ${typeArray[j]} ${currentPercentage !== stackedArray[j]
            ? Math.round(stackedArray[j] * objectiveSavings)
            : 'Everything'} from ${inputNameArray[j]} savings`;
        } else if (percentagesList[j] === percentagesList[0]) {
          // Equal no error
          advisoryArray[j] = percentagesList[j];
          stackedArray[j] = 0;
          typeArray[j] = 'OKAY';
          advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
        } else {
          // Below no error, just advisory
          advisoryArray[j] = percentagesList[j];
          stackedArray[j] = percentagesList[0] - percentagesList[j];
          typeArray[j] = 'Deposit';
          advisoryStringArray[j] = `Please ${typeArray[j]} ${Math.round(
            stackedArray[j] * objectiveSavings
          )} in ${inputNameArray[j]} savings`;
        }
      }
      let Summedcomponent = 0;

      for (let i = 1; i < percentagesList.length; i++) {
        let diff = decider - percentagesList[i];
        let value = diff / (percentagesList.length - 1);

        if (diff === 0) {
          value = 0;
        }
        Summedcomponent = Summedcomponent + value;
      }

      let total = (decider - Summedcomponent) * 100;

      /// Advisory work

      return {
        name: `Reduce savings pair number : ${i + 1} by ${Math.round(reduceBy)}`,
        message: percentagesList,
        advisoryArray,
        stackedArray,
        typeArray,
        total,
        advisoryStringArray
      };
    }
  }

  let Summedcomponent = 0;

  for (let i = 1; i < percentagesList.length; i++) {
    let diff = decider - percentagesList[i];
    let value = diff / (percentagesList.length - 1);

    if (diff === 0) {
      value = 0;
    }
    Summedcomponent = Summedcomponent + value;
  }

  let total = (decider - Summedcomponent) * 100;
  // console.log(total);
  /// Advisory work
  let advisoryArray = new Array(percentagesList.length);
  let stackedArray = new Array(percentagesList.length);
  let typeArray = new Array(percentagesList.length);
  let advisoryStringArray = new Array(percentagesList.length);

  for (let j = 0; j < percentagesList.length; j++) {
    let currentSavings = args[j * 2];
    let objectiveSavings = args[j * 2 + 1];
    if (percentagesList[j] > percentagesList[0]) {
      // More error
      advisoryArray[j] = percentagesList[0];
      stackedArray[j] = percentagesList[j] - percentagesList[0];
      typeArray[j] = 'Withdraw';

      let currentPercentage = currentSavings / objectiveSavings;
      advisoryStringArray[j] = `Please ${typeArray[j]} ${currentPercentage !== stackedArray[j]
        ? Math.round(stackedArray[j] * objectiveSavings)
        : 'Everything'} from ${inputNameArray[j]} savings`;
    } else if (percentagesList[j] === percentagesList[0]) {
      // Equal no error
      advisoryArray[j] = percentagesList[j];
      stackedArray[j] = 0;
      typeArray[j] = 'OKAY';
      advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
    } else {
      // Below no error, just advisory
      advisoryArray[j] = percentagesList[j];
      stackedArray[j] = percentagesList[0] - percentagesList[j];
      typeArray[j] = 'Deposit';
      advisoryStringArray[j] = `Please ${typeArray[j]} ${Math.round(
        stackedArray[j] * objectiveSavings
      )} in ${inputNameArray[j]} savings`;
    }
  }
  /// Advisory work

  let progressObject = {};
  if (complete(percentagesList)) {
    progressObject = {
      message: 'Congratulations, you have completed your savings',
      total: total,
      results: percentagesList,
      advisoryArray,
      stackedArray,
      typeArray,
      advisoryStringArray
    };
  } else {
    progressObject = {
      message: `Your total percentage is ${Math.round(total)}%`,
      total: total,
      results: percentagesList,
      advisoryArray,
      stackedArray,
      typeArray,
      advisoryStringArray
    };
  }

  return progressObject;
}

function downwardLinear(inputsArray, inputNameArray) {
  let args = inputsArray;
  let percentagesList = percentages(args);

  let leadIncompletePercentage;
  let incompleteIndices = [];

  for (let i = 0; i < percentagesList.length; i++) {
    if (percentagesList[i] < 1) {
      incompleteIndices.push(i); // Stores indices of incomplete savings
    }
  }

  leadIncompletePercentage = percentagesList[incompleteIndices[0]];
  // console.log(leadIncompletePercentage)
  let numberOfRemainingIncompleteBuffers = incompleteIndices.length;

  let gradient = leadIncompletePercentage / numberOfRemainingIncompleteBuffers;

  let nearlyCompleted = false;

  let completedLength = percentagesList.length - incompleteIndices.length;

  if (completedLength === percentagesList.length - 1 && incompleteIndices[0] !== incompleteIndices[1] + 1) {
    nearlyCompleted = true;
  }

  if (incompleteIndices[0] !== incompleteIndices[1] - 1) {
    completedLength = 0;
  }

  for (let i = 0; i < percentagesList.length; i++) {
    if (i > 0 && !nearlyCompleted && i > completedLength) {
      let gradValue = percentagesList[i - 1] - gradient;

      if (gradValue < 0) {
        gradValue = 0;
      }

      if (percentagesList[i] > gradValue) {
        let tresspass = gradValue * args[i * 2 - 1];

        if (tresspass < 0) {
          tresspass = 0;
        }

        /// Advisory work
        let advisoryArray = new Array(percentagesList.length);
        let stackedArray = new Array(percentagesList.length);

        let indicesOfIncompleteInner = [];
        for (let k = 0; k < percentagesList.length; k++) {
          if (percentagesList[k] < 1) {
            indicesOfIncompleteInner.push(k);
          }
        }

        let typeArray = new Array(percentagesList.length);
        let advisoryStringArray = new Array(percentagesList.length);

        let innerGradient =
          percentagesList[indicesOfIncompleteInner[0]] / (indicesOfIncompleteInner.length - 1);
        let counterWithin = 1;
        for (let j = 0; j < percentagesList.length; j++) {
          let currentSavings = args[j * 2];
          let objectiveSavings = args[j * 2 + 1];

          if (j <= indicesOfIncompleteInner[0]) {
            // Everything below or equal to first incomplete
            advisoryArray[j] = percentagesList[j];
            stackedArray[j] = 0;

            typeArray[j] = 'OKAY';
            advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
          } else {
            // Everything after the first incomplete one
            let innerGradValue =
              percentagesList[indicesOfIncompleteInner[0]] - innerGradient * counterWithin;
            if (innerGradValue < 0) {
              innerGradValue = 0;
            }

            if (innerGradValue > percentagesList[j]) {
              advisoryArray[j] = percentagesList[j];
              stackedArray[j] = innerGradValue - percentagesList[j];

              typeArray[j] = 'Deposit';
              advisoryStringArray[j] = `Please ${typeArray[j]} ${Math.round(
                stackedArray[j] * objectiveSavings
              )} in ${inputNameArray[j]} savings`;
            } else if (innerGradValue === percentagesList[j]) {
              advisoryArray[j] = percentagesList[j];
              stackedArray[j] = 0;

              typeArray[j] = 'OKAY';
              advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
            } else {
              advisoryArray[j] = innerGradValue;
              stackedArray[j] = percentagesList[j] - innerGradValue;

              typeArray[j] = 'Withdraw';
              let currentPercentage = currentSavings / objectiveSavings;
              advisoryStringArray[j] = `Please ${typeArray[j]} ${currentPercentage !== stackedArray[j]
                ? Math.round(stackedArray[j] * objectiveSavings)
                : 'Everything'} from ${inputNameArray[j]} savings`;
            }

            counterWithin++;
          }
        }
        let totalPartial;

        if (nearlyCompleted) {
          let whichAreCompleted = percentagesList.length - 1;
          let newGrad = 100 / percentagesList.length;

          totalPartial =
            newGrad * whichAreCompleted + percentagesList[percentagesList.length - 1] * newGrad;
        } else {
          totalPartial = percentagesList.reduce((a, b) => a + b, 0) * 100 / percentagesList.length;
        }
        /// Advisory work

        return {
          name: `You cannot save beyond : ${Math.round(tresspass)} for savings ${i + 1}`,
          message: percentagesList,
          advisoryArray,
          stackedArray,
          typeArray,
          advisoryStringArray,
          total: totalPartial
        };
      }
    }

    if (nearlyCompleted) {
      let whichAreCompleted = percentagesList.length - 1;
      let newGrad = 100 / percentagesList.length;

      let totalPartial = newGrad * whichAreCompleted + percentagesList[percentagesList.length - 1] * newGrad;

      // console.log((newGrad));

      let progressObject = {};
      /// Advisory work
      let advisoryArray = new Array(percentagesList.length);
      let stackedArray = new Array(percentagesList.length);

      let indicesOfIncompleteInner = [];
      for (let k = 0; k < percentagesList.length; k++) {
        if (percentagesList[k] < 1) {
          indicesOfIncompleteInner.push(k);
        }
      }

      let typeArray = new Array(percentagesList.length);
      let advisoryStringArray = new Array(percentagesList.length);

      let innerGradient =
        percentagesList[indicesOfIncompleteInner[0]] / (indicesOfIncompleteInner.length - 1);
      let counterWithin = 1;
      for (let j = 0; j < percentagesList.length; j++) {
        let currentSavings = args[j * 2];
        let objectiveSavings = args[j * 2 + 1];

        if (j <= indicesOfIncompleteInner[0]) {
          // Everything below or equal to first incomplete
          advisoryArray[j] = percentagesList[j];
          stackedArray[j] = 0;

          typeArray[j] = 'OKAY';
          advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
        } else {
          // Everything after the first incomplete one
          let innerGradValue =
            percentagesList[indicesOfIncompleteInner[0]] - innerGradient * counterWithin;
          if (innerGradValue < 0) {
            innerGradValue = 0;
          }

          if (innerGradValue > percentagesList[j]) {
            advisoryArray[j] = percentagesList[j];
            stackedArray[j] = innerGradValue - percentagesList[j];

            typeArray[j] = 'Deposit';
            advisoryStringArray[j] = `Please ${typeArray[j]} ${Math.round(
              stackedArray[j] * objectiveSavings
            )} in ${inputNameArray[j]} savings`;
          } else if (innerGradValue === percentagesList[j]) {
            advisoryArray[j] = percentagesList[j];
            stackedArray[j] = 0;

            typeArray[j] = 'OKAY';
            advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
          } else {
            advisoryArray[j] = innerGradValue;
            stackedArray[j] = percentagesList[j] - innerGradValue;

            let currentPercentage = currentSavings / objectiveSavings;

            typeArray[j] = 'Withdraw';
            advisoryStringArray[j] = `Please ${typeArray[j]} ${currentPercentage !== stackedArray[j]
              ? Math.round(stackedArray[j] * objectiveSavings)
              : 'Everything'} from ${inputNameArray[j]} savings`;
          }

          counterWithin++;
        }
      }
      /// Advisory work
      return (progressObject = {
        message: `Your total progress is ${Math.round(totalPartial)}%`,
        total: totalPartial,
        results: percentagesList,
        advisoryArray,
        stackedArray,
        typeArray,
        advisoryStringArray
      });
    }
  }

  let total = percentagesList.reduce((a, b) => a + b, 0) * 100 / percentagesList.length;

  // console.log(percentagesList);

  let progressObject = {};
  /// Advisory work
  let advisoryArray = new Array(percentagesList.length);
  let stackedArray = new Array(percentagesList.length);

  let indicesOfIncompleteInner = [];
  for (let k = 0; k < percentagesList.length; k++) {
    if (percentagesList[k] < 1) {
      indicesOfIncompleteInner.push(k);
    }
  }

  let typeArray = new Array(percentagesList.length);
  let advisoryStringArray = new Array(percentagesList.length);

  let innerGradient = percentagesList[indicesOfIncompleteInner[0]] / (indicesOfIncompleteInner.length - 1);
  let counterWithin = 1;
  for (let j = 0; j < percentagesList.length; j++) {
    let currentSavings = args[j * 2];
    let objectiveSavings = args[j * 2 + 1];

    if (j <= indicesOfIncompleteInner[0]) {
      // Everything below or equal to first incomplete
      advisoryArray[j] = percentagesList[j];
      stackedArray[j] = 0;

      typeArray[j] = 'OKAY';
      advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
    } else {
      // Everything after the first incomplete one
      let innerGradValue = percentagesList[indicesOfIncompleteInner[0]] - innerGradient * counterWithin;
      if (innerGradValue < 0) {
        innerGradValue = 0;
      }

      if (innerGradValue > percentagesList[j]) {
        advisoryArray[j] = percentagesList[j];
        stackedArray[j] = innerGradValue - percentagesList[j];

        typeArray[j] = 'Deposit';
        advisoryStringArray[j] = `Please ${typeArray[j]} ${Math.round(
          stackedArray[j] * objectiveSavings
        )} in ${inputNameArray[j]} savings`;
      } else if (innerGradValue === percentagesList[j]) {
        advisoryArray[j] = percentagesList[j];
        stackedArray[j] = 0;

        typeArray[j] = 'OKAY';
        advisoryStringArray[j] = `Savings are ${typeArray[j]}`;
      } else {
        advisoryArray[j] = innerGradValue;
        stackedArray[j] = percentagesList[j] - innerGradValue;
        let currentPercentage = currentSavings / objectiveSavings;
        typeArray[j] = 'Withdraw';
        advisoryStringArray[j] = `Please ${typeArray[j]} ${currentPercentage !== stackedArray[j]
          ? Math.round(stackedArray[j] * objectiveSavings)
          : 'Everything'} from ${inputNameArray[j]} savings`;
      }

      counterWithin++;
    }
  }
  /// Advisory work

  if (complete(percentagesList)) {
    progressObject = {
      message: 'Congratulations, you have completed your savings',
      total: total,
      results: percentagesList,
      advisoryArray,
      stackedArray,
      typeArray,
      advisoryStringArray
    };
  } else {
    progressObject = {
      message: `Your total progress is ${Math.round(total)}%`,
      total: total,
      results: percentagesList,
      advisoryArray,
      stackedArray,
      typeArray,
      advisoryStringArray
    };
  }

  return progressObject;
}


export function methodChooser(arg, inputsArray, inputNameArray){
  switch(arg){
    case 'conservative':
      return conservative(inputsArray,inputNameArray);
    case 'equiservative':
      return equiservative(inputsArray,inputNameArray);
    case 'downwardLinear':
      return downwardLinear(inputsArray,inputNameArray);
  }
}









// WEBPACK FOOTER //
// ./src/store/chart.js